import { showHelpContent } from "../../features/assets/asset-utils";

export function AssetLibEntryHelp(props: { data : any }) {
  const helpRequested = () => {
    showHelpContent();
  }

  return (
    <div className='gallery_product col-lg-1 col-md-1 col-sm-1 col-xs-1' onClick={helpRequested}>
      <a href={props.data.url} target="_blank" rel="noreferrer"><p className='text-center'>{props.data.name}</p></a>
    </div>
    );
}
